import { useQuery } from '@tanstack/react-query';
import { getAssignment, getUserDetailsFormData } from '../api';
import { useAuth } from '../hooks';

export const useGetAssignment = (assignmentId) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ['get-assignment'],
    queryFn: () => getAssignment({ assignmentId, token })
  });
};

export const useGetStudentDetailsFormData = (assignmentId) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ['get-student-details-form-data'],
    queryFn: () => getUserDetailsFormData({ assignmentId, token }),
    enabled: !!token && !!assignmentId
  });
};
  
